// extracted by mini-css-extract-plugin
module.exports = {"StackedBar":"StackedBar_StackedBar__eAzRt"};